export default __webpack_public_path__ + "static/media/edcb2532446f02055ec73b51cbf43e841629986086944.a86da155.webp";